import "./Header.css";

export default function Header() {
  return (
    <h1 className="Header">
      <span className="title-name">How's the weather?</span>
    </h1>
  );
}
